import React from 'react'
import styled from 'styled-components'
import { Icon } from '../../atoms/Icon'
import { IconName } from '../../atoms/Icon/Icon.types'
import { PropertySectionTitle } from '../PropertyPanelStyles'

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`

interface SectionHeaderWithIconProps {
  children: React.ReactNode
  icon?: IconName
}

export const SectionHeaderWithIcon: React.FC<SectionHeaderWithIconProps> = ({
  children,
  icon,
}) => {
  return (
    <HeaderWrapper>
      {icon && <Icon name={icon} size="medium" />}
      <PropertySectionTitle>{children}</PropertySectionTitle>
    </HeaderWrapper>
  )
}
